//components and link
import TheNavbar from "../Components/navbar"
import Footer from "../Components/footer"
import React from "react"
import { Row, Col } from "react-bootstrap"
import EachSong from "../Components/musicHome/eachsong"
import { graphql, StaticQuery } from "gatsby"
import "../Styles/musicsecs.scss"
import Albumslider from "../Components/imagesliders/albumsslider"
import Suggestions from "../Components/musicHome/suggestions"

//style
import "../Styles/index.scss"
const Albumspage = () => {

  return (
    <>
    <div className="app">
      <TheNavbar></TheNavbar>
      <br/>
      <br/>
     
      <div className="the-home-container" style={{ marginRight: "7vw", marginLeft: "7vw" , paddingRight: "7vw", paddingLeft: "7vw" }}>

      <div>
      <br/>
       <br/>
       <Albumslider/>
      <Row>
      <Col md="12" className="music-sec-titles">
        <h1>ALBUMS</h1>

        <div className="div1">
          <div className="div2"></div>
        </div>
      </Col></Row>
        <div className="scroll-container">
      <StaticQuery
        query={topmusic}
        render={data => {
          return (
           
      <Row>
              {data.allMarkdownRemark.edges.map(({ node }) => (
                  <Col xs={6} sm={4} md={3} lg={2}>
                  <EachSong
                    key={node.id}
                    title={node.frontmatter.title}
                    artist={node.frontmatter.artist}
                    date={node.frontmatter.date}
                    slug={node.fields.slug}
                    fluid={node.frontmatter.image.childImageSharp.fluid}
                  />
               </Col>
              ))}
            </Row>
          )
        }}
      /></div>
    </div>

    <span className="badge loadmorebtn" >

      load more

    </span>

<br/>
<br/>
    <Suggestions />
</div>
     <Footer></Footer>
    </div>
  </>
  )
}
const topmusic = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___rate], order: DESC }
      filter: { frontmatter: { cat: { eq: "music" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            rate
            image {
              childImageSharp {
                fluid(maxWidth: 900) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            artist
          }

          fields {
            slug
          }
        }
      }
    }
  }
`

export default Albumspage
